module.exports = __webpack_public_path__ + "static/media/trigProofs1.718c59b4.svg";